// extracted by mini-css-extract-plugin
module.exports = {"card":"InfoCard_card__3NWyy","heading":"InfoCard_heading__1peCq","description":"InfoCard_description__1XIPl","button":"InfoCard_button__cZf1i"};